import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken/* , setToken, setRefreshToken, setTokenExpiresIn */ } from '@/utils/auth'
import { closeWebsocket } from '../utils/webSocket'
import { getDeviceProfile } from '@/utils/device'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  async(config) => {
    // do something before request is sent
    // config.headers['Content-Type'] = 'application/json;charset=utf-8'
    // 👇 如果不是上传请求，就设置为 application/json
    if (config.isUpload !== true) {
      config.headers['Content-Type'] = 'application/json;charset=utf-8'
    }
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['X-Token'] = getToken()
      config.headers['Authorization'] = 'Bearer ' + getToken()
    }
    // 设置语言
    const language = store.getters.language
    const langMap = store.getters.langMap
    if (language in langMap) {
      config.headers['Locale-Language'] = langMap[language]
    }

    try {
      const d = await getDeviceProfile()
      if (d) {
        // 直接使用 config.headers 赋值
        /* eslint-disable require-atomic-updates */
        config.headers['X-Device-Id'] = d.id
        config.headers['X-Device-Ts'] = String(d.ts || Date.now())
        config.headers['X-Device-Tz'] = d.tz || ''
        config.headers['X-Device-Platform'] = d.platform || ''
        config.headers['X-Device-Screen'] = d.screen || ''
        config.headers['X-Device-Cpu'] = d.cpu === '' ? '' : String(d.cpu)
        config.headers['X-Device-Mem'] = d.mem === '' ? '' : String(d.mem)
      }
    } catch (error) {
      console.error('获取设备信息失败:', error)
    }

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

const subscribers = []
let isRefreshing = true

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    if (response.config.responseType === 'blob') {
      return response
    }
    const res = response.data
    if (res.code !== 200) {
      // ACCESS TOKEN TIMEOUT
      if (res.code === 106) {
        if (isRefreshing) {
          store.dispatch('user/refreshToken').then(() => {
            subscribers.forEach((callback) => {
              callback()
            })
            isRefreshing = true
          })
        }
        isRefreshing = false

        return new Promise((resolve) => {
          subscribers.push(() => {
            resolve(service(response.config))
          })
        })
      } else if (/* res.code === 104 || res.code === 107 || */ res.code === 402) { // Token expires;
        // to re-login
        MessageBox.confirm('登陆已过期，是否重新登陆？', '登陆提示', {
          confirmButtonText: '重登',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
            closeWebsocket()
          })
        }).catch(() => {
          isRefreshing = true
        })
        return Promise.reject('登陆已过期')
      } else if (res.code === 401) {
        // return Promise.reject('token过期')
        // to re-login
        MessageBox.confirm('登陆已过期，是否重新登陆？', '登陆提示', {
          confirmButtonText: '重登',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
            closeWebsocket()
          })
        }).catch(() => {
          isRefreshing = true
        })
        return Promise.reject('登陆已过期')
      } else if (res.code === 204) {
        return res
      } else if (res.code === 201) {
        return res
      }

      // 通用错误
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('step 1', error)
    const res = error.response && error.response.data
    const message = (res && res.message) || error.message || 'Error'
    Message({
      message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
